import { C, P0, R, S, abs, core, disc, max, moodK } from '../../geometry';

export const pinwheel = {
  name: 'Pinwheel',
  colors: ['#1FA2D6', '#E5484D'],
  draw(m, t) {
    let spin = 10 * S(t * 0.6),
      r1 = 34,
      pose = P0();
    if (m === 'happy') {
      spin = t * 200;
      r1 = 36;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the blades keep spinning.
    if (m === 'thinking') spin = t * 120;
    if (m === 'talking') r1 = 32 + 5 * max(0, S(t * 10));
    if (m === 'surprised') {
      r1 = 41;
      spin = 2 * S(t * 26);
    }
    if (m === 'paused') {
      r1 = 27;
      spin = 3 * S(t * 0.5);
    }
    return {
      strokes: [0, 1, 2, 3].map((i) => {
        const b = i * 90;
        const pts = [
          [16, b],
          [24, b + 18],
          [r1, b + 52],
        ].map(([r, ad]) => [50 + r * C(ad * R), 52 + r * S(ad * R)]);
        return { c: i % 2 ? 'b' : 'a', pts, spin };
      }),
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.push(core(disc(50, 52, 13 * moodK(m, t))));
    return f;
  },
};
